import { Octokit } from '@octokit/rest'

export default function githubApi(userAgent, token) {
  const github = new Octokit({
    auth: `token ${token}`,
    userAgent,
    baseUrl: 'https://api.github.com',
    request: {
      agent: `Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.${Math.random()}.132 Safari/537.36`,
      timeout: 60,
    },
  })
  return github
}
